import React, { useState } from "react";
import { api_url, DEFAULT_LOGO_SRC, FEMALE_PROFILE_PICTURE, MALE_PROFILE_PICTURE } from "../../constant/constant";
import "./Updategender.css";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
function Updategender() {
  const { t,i18n } = useTranslation();
  const [selectedGender, setSelectedGender] = useState(null); // Track selected gender
  const [error, setError] = useState(null); // Track errors
  const [loading, setLoading] = useState(false); // Track loading state
  const maleAvatar = MALE_PROFILE_PICTURE;
  const femaleAvatar = FEMALE_PROFILE_PICTURE;
  const isArabic = i18n.language === "ar"; // Arabic check

  const user_id = localStorage.user_id;
  const navigate = useNavigate();
  const handleGenderSelect = (gender) => {
    setSelectedGender(gender);
    setError(null); // Clear any previous error
  };
  const handleLoginSubmit = async (e) => {
    const tempToken = localStorage.getItem("userToken");
    try {
      // Proceed with login request
      const response = await fetch(`${api_url}/login`, {
        mode: "cors",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          token: tempToken,
        }),
      });
      if (!response.ok) {
        const errorData = await response.json();
        if (errorData.terms) {
          localStorage.setItem("userToken", errorData.token);
          navigate("/Terms", { state: { terms: errorData.terms } });
        }
        if (errorData.requires_gender_selection) {
          localStorage.user_id = errorData.user.id;
          window.location = "/Updategender";
          return;
        }
      }

      const data = await response.json();
      console.log("data response:", data);
      if (data.user?.force_reset_password === 1) {
        console.log(data.user);
        console.log("force password");
        localStorage.setItem("userToken", data.token);
        localStorage.setItem("userData", JSON.stringify(data.user));
        window.location = "/updatepassword";
        return false;
      }
      console.log("data roleId:", data.user.role_id);
      if (data.user.role_id === 5) {
        localStorage.setItem("userToken", data.token);
        localStorage.setItem("userData", JSON.stringify(data.user));
        if (data?.session_lifetime) {
          localStorage.session_lifetime = data.session_lifetime;
        }
        if (data?.token == null && data?.two_factor_required === true) {
          window.location = "/login";
        }
        if (data.assessment_required == true) {
          localStorage.setItem("questions", JSON.stringify(data.questions));
          window.location = "/UserAssessment";
        } else {
          localStorage.setItem("userToken", data.token);
          localStorage.setItem("userData", JSON.stringify(data.user));
          if (data?.session_lifetime) {
            localStorage.session_lifetime = data.session_lifetime;
          }
          window.location = "/user/dashboard";
        }
      } else {
        // Handle normal login
        localStorage.setItem("userToken", data.token);
        localStorage.setItem("userData", JSON.stringify(data.user));
        if (data?.session_lifetime) {
          localStorage.session_lifetime = data.session_lifetime;
        }
        window.location = "/dashboard";
      }
    } catch (err) {
      console.error(err.message);
    }
  };
  const handleSubmit = async () => {
    if (!selectedGender) {
      setError("Please select a gender");
      return;
    }

    setLoading(true); // Start loading
    try {
      // Send the selected gender to the backend API
      const response = await fetch(api_url + "/update-gender", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("userToken")}`, // Assuming the token is stored in localStorage
        },
        body: JSON.stringify({ gender: selectedGender }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        setError(errorData.message || "Error updating gender");
        setLoading(false);
        return;
      }

      const data = await response.json();
      console.log(data);

      // Check if the response is successful and handle the message
      if (data.status === "success") {
        setError(""); // Clear any previous error
        handleLoginSubmit();
        // window.location = '/login'; // Redirect to the login page or any other route
      } else {
        setError(t("genderUpdateFailed"));
      }
    } catch (err) {
      setError(t("errorSubmittingGender"));
    } finally {
      setLoading(false); // Ensure loading state is always reset
    }
  };
  return (
    <div className="loginLogo mt-5" align="center">
      <img src={DEFAULT_LOGO_SRC } alt="Cyber Sense" style={{width:'160px'}}/>
      <div
        className="card mt-5 pb-5"
        style={{ width: "90%", borderRadius: "30px" }}
      >
        <div className="card-body">
          <div className="position-relative" style={{ height: "80vh" }}>
            {/* Fixed H2 at top center */}
        <div className="card-body">
          <h2 className={isArabic ? "arabic-text" : ""}>{t("selectYourGender")}</h2>

            {/* Main content shifted slightly below to avoid overlap */}
            <div
              className="d-flex flex-column justify-content-center align-items-center text-center h-100"
              style={{
                paddingTop: "80px", // only as much as needed to not overlap the h2
              }}
            >
              {error && <p style={{ color: "black" }}>{error}</p>}

              {/* Avatars */}
              <div className="d-flex flex-column flex-md-row justify-content-center align-items-center gap-4 mb-4 mb-4">
                {/* Male */}
                <div className="text-center">
                  <img
                    src={maleAvatar}
                    alt="Male"
                    onClick={() => handleGenderSelect("male")}
                    style={{
                      width: "150px",
                      height: "150px",
                      border:
                        selectedGender === "male"
                          ? "4px solid black"
                          : "2px solid gray",
                      borderRadius: "50%",
                      cursor: "pointer",
                      transition: "0.3s ease",
                    }}
                  />
                  <p>{t("male")}</p>
                </div>

                {/* Female */}
                <div className="text-center">
                  <img
                    src={femaleAvatar}
                    alt="Female"
                    onClick={() => handleGenderSelect("female")}
                    style={{
                      width: "150px",
                      height: "150px",
                      border:
                        selectedGender === "female"
                          ? "4px solid black"
                          : "2px solid gray",
                      borderRadius: "50%",
                      cursor: "pointer",
                      transition: "0.3s ease",
                    }}
                  />
                  <p>{t("female")}</p>
                </div>
              </div>

              {/* Submit button */}
              <button
                className="btn btn-dark p-2"
                onClick={handleSubmit}
                disabled={loading || !selectedGender}
                style={{
                  width: "30%",
                  backgroundColor: "black",
                  borderColor: "black",
                }}
              >
                {loading ? t('Submitting...') : t('Submit')}
              </button>
            </div>
          </div>
        </div>
      </div>
      </div>
    </div>
  );
}

export default Updategender;
